import { ExactaAPI } from '../api/exactaapi';
var createAddRequest = function (values, executeAlias) {
    var actions = createSetActions(values);
    actions.push({
        type: 'execute',
        alias: executeAlias,
    });
    return actions;
};
var createActions = function (values, type) {
    var actions = [];
    Object.keys(values).forEach(function (key) {
        if (values[key].type && values[key].type === 'relatedProcessMultiple') {
            values[key].values.forEach(function (value) {
                actions.push({
                    type: type,
                    alias: key,
                    value: value,
                });
            });
        }
        else {
            actions.push({
                type: type,
                alias: key,
                value: typeof values[key] === 'object' ? values[key] : "" + values[key],
            });
        }
    });
    return actions;
};
var createSetActions = function (values) {
    return createActions(values, 'set');
};
var createUnsetActions = function (values) {
    return createActions(values, 'unset');
};
var createSingleUpdateRequest = function (alias, id, value) {
    var apiVersion = ExactaAPI.getInstance().getApiVersion();
    var actions = [];
    if (alias) {
        actions.push({
            type: 'set',
            alias: alias,
            value: value,
        });
    }
    return {
        id: id,
        version: apiVersion,
        subscribe: false,
        actions: actions,
    };
};
var createSingleUpdateRequestEmbedded = function (alias, id, value, path) {
    var exactaApi = ExactaAPI.getInstance();
    var apiVersion = exactaApi.getApiVersion();
    var actions = [];
    if (alias) {
        actions.push({
            type: 'embedded',
            value: {
                type: 'edit',
                path: path,
                actions: [
                    {
                        type: 'set',
                        alias: alias,
                        value: value,
                    },
                ],
            },
        });
    }
    return {
        id: id,
        version: apiVersion,
        subscribe: false,
        actions: actions,
    };
};
export { createAddRequest, createSingleUpdateRequest, createSingleUpdateRequestEmbedded, createSetActions, createUnsetActions, };
//# sourceMappingURL=request.js.map